module.exports = __webpack_public_path__ + "img/4.e26583d5.jpg";